export default {
  path: "/",
  name: "error_base",
  component: () => import("@/views/error/ErrorBase.vue"),
  children: [
    {
      path: "500",
      name: "500",
      component: () => import("@/views/error/ServerError.vue")
    },
    {
      path: "403",
      name: "403",
      component: () => import("@/views/error/Forbidden.vue")
    }
  ]
}
